<ng-container
  *ngIf="isReadOnly || bindingFormControl?.readonly; else showInputText"
>
  <div class="p-text-bold-500 break-word" [style]="useStyle">
    {{ this.bindingFormControl?.value | replaceNullWith : replaceNullWith }}
  </div>
</ng-container>
<ng-template #showInputText>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
    [style]="useStyle"
  >
    <input
      *ngIf="render"
      type="text"
      pInputText
      [class]="useCustStyle"
      sigvDetectDefaultValueDifference
      [beforeInputValue]="beforeInputValue"
      [afterInputValue]="afterInputValue"
      [applyDifferenceDetect]="applyDifferenceDetect"
      [style]="maxlength ? { width: useWidth } : {}"
      placeholder=" {{
        (placeholder == undefined ? 'Please Enter' : placeholder) | translate
      }}"
      [formControl]="bindingFormControl"
      (blur)="blurEvent($event)"
      (change)="changeEvent($event)"
    />
  </sigv-form-control-widget>
</ng-template>
